import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'antd';
import { Form as FormikForm, FormItem, Input } from 'formik-antd';

import { getUrlFromEvent } from 'utils/form';
import { SingleFileUpload } from 'components/form/upload';

import StagePropTypes from './prop-types';
import { DB_PREFIX } from './constants';

const Form = ({
  isSubmitting,
  values,
  validateStatus,
  help,
  setFieldValue,
  uploadTo,
  children,
}) => {
  const file = values[DB_PREFIX].fileURL
    ? {
        name: `${DB_PREFIX}.fileURL`,
        url: values[DB_PREFIX].fileURL,
      }
    : undefined;
  return (
    <FormikForm layout="vertical">
      <Alert
        message="Please upload a copy of your current CV."
        description="Please ensure all information contained in your CV is up to date and accurate. The information on it such as address and contact details must match those inputted as part of your registration process, otherwise if there are any differences it may restrict your opportunities with potential employers.
        Above all it needs to be HONEST."
        type="info"
        showIcon
      />
      <FormItem
        name="fileURL"
        label="Upload more recent CV - Word / PDF"
        validateStatus={validateStatus.fileURL}
        help={help.fileURL}
      >
        <SingleFileUpload
          className="ant-upload ant-upload-drag"
          file={file}
          uploadTo={uploadTo}
          multiple={false}
          showUploadList
          disabled={file != null || isSubmitting}
          onClear={() => {
            setFieldValue(`${DB_PREFIX}.fileURL`, null);
          }}
          onChange={(e) => {
            setFieldValue(`${DB_PREFIX}.fileURL`, getUrlFromEvent(e));
          }}
        />
      </FormItem>
      <FormItem
        name={`${DB_PREFIX}.text`}
        label="Please enter a brief overview of your work experience"
      >
        <Input.TextArea name={`${DB_PREFIX}.text`} />
      </FormItem>

      {children}
    </FormikForm>
  );
};

Form.propTypes = {
  children: PropTypes.node,
  uploadTo: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  values: StagePropTypes.isRequired,
  help: StagePropTypes.isRequired,
  validateStatus: StagePropTypes.isRequired,
};

Form.defaultProps = {
  children: null,
  isSubmitting: false,
};

export default Form;
